import { Component, OnInit, Input, OnDestroy, Output, EventEmitter , ViewChild, ElementRef} from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup } from '@angular/forms';

import { BaseFormGroup } from '../../../shared/form-input-components/base-form-group';
import { CommonService } from '../../../shared/services/common.service';
import { CreateBookingService } from '../create-booking.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import moment from 'moment-timezone';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-confirm-request',
  templateUrl: './confirm-request.component.html',
  styleUrls: ['./confirm-request.component.scss']
})
export class ConfirmRequestComponent extends BaseFormGroup implements OnInit, OnDestroy {

  @Input() formDetails: FormGroup;
  @Input() workflowConfig;
  @Input() customManagerPopups = false;
  @Input() miscellConfig: any;
  @Input() configComplete: any;
  @Input() escortConfig: any;
  @Output() needMangerApproval: EventEmitter<Boolean> = new EventEmitter();
  @Output() submitBookingWithManager: EventEmitter<Boolean> = new EventEmitter();
  @Output() closeDialogbox: EventEmitter<boolean> = new EventEmitter();
  @ViewChild('search', { static: false }) inputName: ElementRef;
  public requesterConfig: any[];
  public cabConfig: any;
  public request: any;
  destroy$ = new Subject();
  config: any;
  showManagerApprovalPopup;
  riderNameAndEmailMap = {};
  approvalManagersList = [];
  managerRole;
  showPoup = false;
  selectedValue: any;
  showDialog: boolean;
  showError: boolean;
  restrictBookingCreation;
  showErrorMessage: boolean;
  showCustomManagerConfig: boolean;
  selectedManager = false;
  showList = false;
  isTyping = false;
  empList;
  showManagerError: boolean;
  selectedEmail: any;
  selectedName: string;
  uploadedDocumentList: any = [];

  constructor(
    private commonService: CommonService,
    private createBookingService: CreateBookingService,
    private router: Router,
    private authService: AuthService
  ) {
    super();
  }

  ngOnInit() {
    if (!this.createBookingService.isEditMode) {
      this.createBookingService.fetchManageApprovalWorkflowConfig().
      pipe(takeUntil(this.destroy$)).
      subscribe((response) => {
        this.config = response['approvalFlowValidationCriteria'];
        this.showDialog= this.workflowConfig['managerApproval'] && !this.isRiderDesignationMatching(this.formDetails.get('userDetails').get('riders'))

        this.restrictBookingCreation = response['restrictBookingCreationIfApproverMissing'];
        this.managerRole = response['firstApprovalWorkFlow']['approver'];
        if (this.isManagerApprovalRequired()) {
          this.createBookingService.isManagerApprovalRequired(true);
          this.createBookingService.fetchEmailListOfManagers(Object.keys(this.riderNameAndEmailMap)).
          pipe(takeUntil(this.destroy$)).
          subscribe((res) => {
            this.formatList(res);
          });
        }
      });

      this.createBookingService.showPopUp.
      pipe(takeUntil(this.destroy$)).
      subscribe((res) => {
        this.showPoup = true;
      });
    }

    this.requesterConfig = this.commonService.getConfigForElementKey('Requester Form', this.configComplete).elementConfigList;
    this.cabConfig = this.commonService.getConfigForElementKey('Trip Details Form', this.configComplete).elementConfigList;
    this.request = this.createBookingService.convertFormToRequestCard(this.formDetails);

    this.showCustomManagerConfig = this.workflowConfig.customReportingManager;

    this.createBookingService.savedDocuments.subscribe(res => this.uploadedDocumentList = res);
  }

  formatList(managerList) {
    this.approvalManagersList = managerList.reduce((acc, list, index) => {
      if (list[this.managerRole] && list[this.managerRole].email) {
        const manager = this.managerRole === 'reportingManager' ? 'Reporting Manager' : 'Team Manager';
        acc.push({
          value : list.emailID,
          label : `${this.riderNameAndEmailMap[list.emailID]}'s ${manager}`
        });
        return acc;
      } else {
        if (acc.length === 0) {
          acc = [];
        }
        return acc;
      }
    }, []);
    if (this.approvalManagersList && this.approvalManagersList.length > 0) {
      if (this.approvalManagersList.length === 1) {
        // this.showDialog = true;
        this.selectedValue = this.approvalManagersList[0]['value'];
        this.createBookingService.setApproverEmail(this.approvalManagersList[0]['value']);
      } else {
          this.showPoup = true;
      }
    } else {
      if (this.restrictBookingCreation) {
        this.showErrorMessage = true;
      } else {
        // this.showDialog = true;
      }
    }
  }

  checkIfConditionMeet(configKey, controlKey, control) {
    if (control.get(controlKey) && !control.get(controlKey).value) {
      return false;
    }
    if (this.config[configKey].length === 1 && this.config[configKey][0] === 'ALL') {
      return true;
    }
    // check for booking type as value other than ALL in the list
    if (this.config[configKey].findIndex((type) => type.toLowerCase() === control.get(controlKey).value.toLowerCase()) > -1) {
      return true;
    }
  }

  // check for designation of rider
  isRiderDesignationMatching(riderControl) {
    if (this.config['riderDesignationIsNot'].length === 0) {
      return false;
    }
    if (this.config['riderDesignationIsNot'].length === 1 && this.config['riderDesignationIsNot'][0] === 'ALL') {
      return false;
    }
    for (const control of riderControl['controls']) {
      if (this.config['riderDesignationIsNot'].
        findIndex((type) => control.get('designation').value && type.toLowerCase() === control.get('designation').value.toLowerCase()) > -1) {
        return true;
      }
    }
  }

  isManagerApprovalRequired() {

    if (this.workflowConfig['managerApproval']) {
    const dateWiseData = this.formDetails.get('tripDetails').get('dateWise')['controls'];
    // map for rider with its gender for checks related to gender time
    const riderGenderMap = {};
    for (const control of this.formDetails.get('userDetails').get('riders')['controls']) {
      riderGenderMap[control.get('travellerId').value] = control.get('gender').value;
      if (control.get('riderTypeId').value === 'Guest') {
      } else {
        this.riderNameAndEmailMap[control.get('email').value] = control.get('name').value;
      }
    }
    if (Object.keys(this.riderNameAndEmailMap).length === 0) {
      this.riderNameAndEmailMap[this.formDetails.get('userDetails').get('requester').get('email').value
      || this.authService.user.info.employee.emailId] = 'Guest Rider';
    }

    for (const control of dateWiseData) {
      for (const cabControl of control.get('cabs')['controls']) {


        // check for rider designation
        if (this.isRiderDesignationMatching(this.formDetails.get('userDetails').get('riders'))) {
        return false;
        }

        // check for booking type condition
        if (this.checkIfConditionMeet('bookingType', 'spotBookingType', cabControl)) {
        return true;
        }

        // check for cab type condition
        if (this.checkIfConditionMeet('cabType', 'vehicleType', cabControl)) {
        return true;
        }

        // check for city condition
        if (this.checkIfConditionMeet('city', 'city', cabControl)) {
        return true;
        }

        // check for destination city condition
        if (this.checkIfConditionMeet('destinationCity', 'destinationCity', cabControl)) {
         return true;
        }

        // check for gender - time combination
        if (this.config['genderAndTripTime']['startTime'] !== '' &&
          this.config['genderAndTripTime']['endTime'] !== '' &&
          this.checkForRiderGenderAndTime(cabControl, riderGenderMap)) {
          return true;
        }
      }
    }
    return false;
    }
  }

  checkForRiderGenderAndTime(cabData, riderGenderMap) {
    const stops = cabData.get('stops');
    for (let i = 0; i < stops.controls.length - 1; i++) {
      const ridersControl = stops.controls[i].get('riders');
      for (const rider of ridersControl['controls']) {
        if (this.config['genderAndTripTime']['gender'][0] === 'ALL' && rider.get('boardingType').value === 'PickUp') {
          if (this.checkTimeForStops(stops.controls[i].get('time').value)) {
            return true;
          }
        } else if (rider.get('boardingType').value === 'PickUp' &&
          this.config['genderAndTripTime']['gender'].findIndex((gen) => gen === riderGenderMap[rider.get('name').value]) > -1) {
          if (this.checkTimeForStops(stops.controls[i].get('time').value)) {
            return true;
          }
        }
      }
    }
  }

  checkTimeForStops(time: string) {
    const startTime = this.config['genderAndTripTime']['startTime'];
    const endTime = this.config['genderAndTripTime']['endTime'];
    let timeIn12HrFormat;
    if (time.endsWith('AM') || time.endsWith('PM')) {
      timeIn12HrFormat = moment(time, 'hh:mm A');
    } else {
      timeIn12HrFormat = moment(moment(time, 'hh:mm').format('hh:mm A'), 'hh:mm A');
    }
    let endTimeMoment;
    let endTimeMomentClone;
    const startTimeMoment = moment(moment(startTime, 'HH:mm').format('hh:mm A'), 'hh:mm A');
    if (Number(startTime.replace(':', '')) > Number(endTime.replace(':', ''))) {
      endTimeMomentClone = moment(moment(endTime, 'HH:mm').format('hh:mm A'), 'hh:mm A');
      endTimeMoment = moment(moment(endTime, 'HH:mm').format('hh:mm A'), 'hh:mm A').add(1, 'day');
    } else {
      endTimeMoment = moment(moment(endTime, 'HH:mm').format('hh:mm A'), 'hh:mm A');
    }
    if (timeIn12HrFormat.isAfter(startTimeMoment) && timeIn12HrFormat.isBefore(endTimeMoment)
     || timeIn12HrFormat.isBefore(endTimeMomentClone)) {
      return true;
    }
  }

  onManagerChange(value) {
    this.selectedValue = value;
    this.showError = false;
  }

  cancelCallback() {
    if (this.showDialog) {
      this.showDialog = false;
      this.router.navigate(['bookings-view']);
    }
    this.showPoup = false;
    this.showError = false;
  }

  onSubmitClick() {
    if (this.selectedValue) {
      this.showPoup = false;
      this.createBookingService.setApproverEmail(this.selectedValue);
    } else {
      this.showError = true;
    }
  }

  makeButtonSubmitEnable() {
    this.showDialog = false;
    this.needMangerApproval.emit(true);
  }

  submitManager(){
    if (this.selectedManager){
      this.createBookingService.approvalEmail.next( this.selectedEmail);
      this.submitBookingWithManager.emit(true);
    } else {
    this.showManagerError = true;
    }

  }
  clearManager() {
    this.selectedManager = false;
    this.isTyping = false;
    this.inputName.nativeElement.value = "";
    this.selectedEmail = "";
  }

  gobackToBookingView()  {
    this.router.navigate(['bookings-view']);
  }

  getManager(searchQuery: any) {
    if (searchQuery === "") {
      this.isTyping = false;
      this.showList = false;
    }
    this.isTyping = true;
    this.createBookingService.fetchEmployees(searchQuery).subscribe((res) => {
      this.showList = true;
      this.empList = res;
    });
  }
  selectedEmp(selected) {
    this.selectedEmail = selected.emailId;
    this.selectedName = selected.employeeName;
    this.showList = false;
    this.selectedManager = true;
    this.inputName.nativeElement.value = this.selectedName;
    this.showManagerError = false;
  }

  closeDialog(){
    this.closeDialogbox.emit(false);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.createBookingService.setApproverEmail("");
    this.createBookingService.showWarningDialog(false);
    this.createBookingService.isManagerApprovalRequired(false);
  }

}
